import { TableRow, TableCell, Skeleton, Stack, Box } from '@mui/material';

export default function TableSkeleton({ rows = 5, columns = 6, hasAvatar = false, hasCheckbox = false }) {
  return Array.from({ length: rows }, (_, i) => (
    <TableRow key={i}>
      {hasCheckbox && (
        <TableCell padding="checkbox">
          <Skeleton variant="rounded" width={18} height={18} />
        </TableCell>
      )}
      {Array.from({ length: columns }, (__, j) => (
        <TableCell key={j}>
          {j === 0 && hasAvatar ? (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Skeleton variant="circular" width={36} height={36} />
              <Skeleton variant="text" width={120} />
            </Stack>
          ) : (
            <Skeleton variant="text" width={j === columns - 1 ? 40 : `${60 + Math.random() * 30}%`} />
          )}
        </TableCell>
      ))}
    </TableRow>
  ));
}
